import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCoursesAPI,
} from "../../../redux/features/intructorSlice";
import { getAllCourseCategoriesAPI } from "../../../redux/features/adminSlice";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import TabFilterCourse from "../../../components/TabFilterCourse/TabFilterCourse";
import TabFilterContentCourse from "../../../components/TabFilterContentCourse/TabFilterContentCourse";
import AdminNotification from "../../../components/Notification/AdminNotification";

// Define course categories outside the component
const COURSE_CATEGORIES = ["All Courses"];

export default function AdminCourses() {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [allCourses, setAllCourses] = useState([]);
  const [activeCourse, setActiveCourse] = useState("All Categories");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filteredCategory, setFilteredCategory] = useState([]);
  

  useEffect(() => {
    const fetchCourses = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const [allCoursesResult, allCourseCategories] = await Promise.all([
          dispatch(getAllCoursesAPI({ token: auth.token })).unwrap(),
          dispatch(getAllCourseCategoriesAPI({ token: auth.token })).unwrap(),
        ]);

        if (allCoursesResult.success) {
          setAllCourses(allCoursesResult.data);
        }
        if (allCourseCategories.success) {
          let filterArr = [];
          allCourseCategories.data.map(item => filterArr.push(item.name))
          setFilteredCategory(["All Categories", ...filterArr]);
        }
      } catch (error) {
        setError("Failed to fetch courses. Please try again.");
        console.error("Failed to fetch courses:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourses();
  }, [auth.token, dispatch]);

  const filteredCard = useMemo(() => {
    if (activeCourse === "All Categories") {
      return allCourses;
    }
    return allCourses.filter(
      (course) => course.Category.name === activeCourse
    );
  }, [activeCourse, allCourses]);

  return (
    <>
    {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
    <div className="instructor-courses">
      {/* Top Bar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">All Courses</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>


      <div className="card-default-style py-42">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <h1 className="fw-bold ah-heading-03 mb-12">Courses</h1>
            <p className="fw-semibold mb-lg-32 text-gray-01">
              Dive into our extensive and diverse range of courses, meticulously
              designed to inspire and empower you to learn something new and
              exciting every single day!
            </p>
          </div>
        </div>

        {/* Course Filters and List */}
        <div className="row">
          <div className="col-12 text-center">
            <TabFilterCourse
              categories={filteredCategory}
              activeCourse={activeCourse}
              setActiveCourse={setActiveCourse}
            />
          </div>
          <div className="col-12">
            {isLoading ? (
              <p>Loading courses...</p>
            ) : error ? (
              <p className="alert alert-danger">{error}</p>
            ) : (
              <div className="row course-item-list">
                <TabFilterContentCourse data={filteredCard} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}